import type { ReactNode } from 'react'
import { cn, formatTimer, useLiveSeconds } from '@/shared/lib'

interface RunningTimerProps {
  startedAt: string
  label?: string
  size?: 'sm' | 'md'
  action?: ReactNode
  className?: string
}

// «Идёт время сейчас» — единственное (вместе с primary-CTA) санкционированное
// использование accent. Живой тик от startedAt (docs/design/README.md §4).
export function RunningTimer({
  startedAt,
  label,
  size = 'md',
  action,
  className,
}: RunningTimerProps) {
  const seconds = useLiveSeconds(startedAt)
  return (
    <span
      role="timer"
      aria-label={`Идёт время: ${formatTimer(seconds)}`}
      className={cn('inline-flex items-center gap-2', className)}
    >
      <span className="dot-pulse size-2 shrink-0 rounded-pill bg-accent" aria-hidden />
      <span
        data-numeric
        className={cn('mono-num text-accent', size === 'md' ? 'text-base' : 'text-sm')}
      >
        {formatTimer(seconds)}
      </span>
      {label && <span className="text-xs text-text-tertiary">{label}</span>}
      {action}
    </span>
  )
}
